import type { QualificationAttribute } from '../../../types/JobAttribute';

import { useUpdateJobSeekerAttributesMutation } from './__generated__/useUpdateJobSeekerAttributeWithSentiment.gqlgenerated';
import { getAttributesInput } from './getAttributesInput';

import { useCallback } from 'react';

export function useUpdateJobSeekerAttributeWithSentiment() {
    const [updateJobSeekerAttributeMutation] = useUpdateJobSeekerAttributesMutation();
    return useCallback(
        async ({
            attribute,
            sentiment,
        }: {
            attribute: QualificationAttribute;
            sentiment: boolean;
        }) => {
            const input = getAttributesInput(attribute, sentiment);
            return updateJobSeekerAttributeMutation({ variables: { input } });
        },
        [updateJobSeekerAttributeMutation],
    );
}
